import {
  ActionBaseMinerTypes,
  ActionSetMinerTypes,
  ActionTypesMinerTypesE,
} from "./actionTypes";

interface IMinerTypeState {
  all_miner_types: string[] | null;
  miner_types: string[] | null;
}

const initialState = {
  all_miner_types: null,
  miner_types: null,
};

const reducer = (
  state: IMinerTypeState = initialState,
  action: ActionBaseMinerTypes
) => {
  switch (action.type) {
    case ActionTypesMinerTypesE.SET_ALL_MINER_TYPES:
      const { miner_types } = (action as ActionSetMinerTypes).payload;
      return {
        ...state,
        all_miner_types: [...miner_types],
      };
    case ActionTypesMinerTypesE.SET_MINER_TYPES:
      const payload = (action as ActionSetMinerTypes).payload;
      return {
        ...state,
        miner_types: [...payload.miner_types],
      };
    case ActionTypesMinerTypesE.CLEAR_MINER_TYPES:
      return {
        ...state,
        miner_types: null,
        all_miner_types: null,
      };

    default:
      return state;
  }
};

export default reducer;
